import React from 'react';
import PropTypes from 'prop-types';

export const Policy = ({ width, height, ...props }) => (
  <svg
    data-icon='policy'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 22c-2.317-.583-4.23-1.913-5.737-3.988C4.754 15.938 4 13.633 4 11.1V5l8-3 8 3v6.1c0 1.417-.242 2.78-.725 4.088A10.624 10.624 0 0 1 17.2 18.65l-3.2-3.2c-.3.183-.62.32-.963.413A3.986 3.986 0 0 1 12 16c-1.1 0-2.042-.392-2.825-1.175C8.392 14.042 8 13.1 8 12s.392-2.042 1.175-2.825C9.958 8.392 10.9 8 12 8s2.042.392 2.825 1.175C15.608 9.958 16 10.9 16 12c0 .367-.046.72-.137 1.063-.092.341-.23.67-.413.987l1.5 1.5c.333-.683.592-1.4.775-2.15.183-.75.275-1.517.275-2.3V6.375l-6-2.25-6 2.25V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3a7.034 7.034 0 0 0 1.238-.512c.391-.209.779-.455 1.162-.738l1.4 1.4c-.55.45-1.146.842-1.788 1.175A9.663 9.663 0 0 1 12 22Zm0-8c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 10c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 12c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Z'
    />
  </svg>
);

Policy.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Policy.defaultProps = {
  width: 24,
  height: 24,
};
